import type { Dayjs } from 'dayjs'
import type { BillCreateInput } from '@super-mega/server/contracts/bill'

export type BillFormValues = Pick<
  BillCreateInput,
  'feeType' | 'description' | 'originalAmount' | 'quantity' | 'unitPrice' | 'note'
> & { period?: [Dayjs, Dayjs]; dueAt?: Dayjs }
export function toBillDraftFields(values: BillFormValues) {
  return {
    feeType: values.feeType,
    description: values.description,
    originalAmount: values.originalAmount ?? null,
    quantity: values.quantity ?? null,
    unitPrice: values.unitPrice ?? null,
    periodStart: values.period?.[0].format('YYYY-MM-DD') ?? null,
    periodEnd: values.period?.[1].format('YYYY-MM-DD') ?? null,
    dueAt: values.dueAt?.format('YYYY-MM-DD') ?? null,
    note: values.note?.trim() || null
  }
}
